<h3 mat-dialog-title>{{title}}</h3>
<mat-dialog-content>
  <div class="w-100 flex-col justify-center items-stretch">
    <span class="text-bold mb-1">Prompt</span>
    <div class="prompt-text mb-3">{{prompt}}</div>

    @if (!running) {
      <div class="menu-item">
        <input #fileInput hidden="true" type="file" (click)="fileInput.value=''" (change)="fileInputChange($event)" accept=".csv,.zip" />
        <a class="w-100" mat-flat-button color="primary" (click)="fileInput.click()">
          <span class="text-bold">Select Test File</span>
        </a>
      </div>
    }
    @if (selectedFile) {
      <span class="mt-2 text-center">Test file: {{selectedFile.name}}</span>
    }
    @if (!running) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mt-3">
        <mat-label>Output file definition (optional)</mat-label>
        <mat-select [(ngModel)]="outputFileDefinitionId">
          <mat-option [value]="undefined">None - the prompt describes the output</mat-option>
          @for (fileDefinition of fileDefinitions; track fileDefinition.id) {
            <mat-option [value]="fileDefinition.id">{{fileDefinition.name}}</mat-option>
          }
        </mat-select>
        <mat-hint>The test output must follow this layout, as with an Apply File Definition step after the AI step</mat-hint>
      </mat-form-field>
    }
    @if (errormessage) {
      <span class="mt-2 text-center warn-color uppercase">{{errormessage}}</span>
    }

    @if (running) {
      <div class="my-4 flex-col justify-center items-center">
        <app-mat-spinner-overlay [diameter]="60" [strokeWidth]="6"></app-mat-spinner-overlay>
        <span class="mt-3 text-bold">Processing the test file... {{elapsedText}}</span>
        <span class="mt-1 text-muted text-center">If no AI worker is running yet, starting one can take up to 4 minutes.</span>
      </div>
    }

    @if (result) {
      <div class="mt-3 flex-col justify-start items-stretch">
        <span class="text-bold uppercase {{statusClass}}">{{statusLabel}}</span>
        @if (result.failureReason) {
          <span class="mt-1">{{result.failureReason}}</span>
        }
        @else if (result.message) {
          <span class="mt-1">{{result.message}}</span>
        }
        <span class="mt-1 text-muted">Duration {{result.durationSeconds | number:'1.0-1'}} s, estimated cost {{result.costUsd | currency:'USD':'symbol':'1.2-4'}}</span>
      </div>
      <mat-tab-group mat-stretch-tabs="false" class="w-100 mt-3">
        @if (result.outputFile) {
          <mat-tab>
            <ng-template mat-tab-label><b>Output</b></ng-template>
            <div class="pt-3">
              @if (outputFileItem) {
                <app-show-file [fileItem]="outputFileItem"></app-show-file>
              }
              @else if (outputZipBlob) {
                <div class="flex-row space-between items-center">
                  <span>{{result.outputFile.fileName}} ({{outputZipSizeText}}) - see the log for the files it contains</span>
                  <mat-button-toggle-group class="mt-2" aria-label="Download">
                    <mat-button-toggle (click)="onDownloadZipClick()" matTooltip="Download"><mat-icon class="text-muted">cloud_download</mat-icon></mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              }
            </div>
          </mat-tab>
        }
        @if (logFileItem) {
          <mat-tab>
            <ng-template mat-tab-label><b>Log</b></ng-template>
            <div class="pt-3">
              <app-show-file [fileItem]="logFileItem"></app-show-file>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
    <a mat-button color="primary" class="dialog-btn mr-5" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button color="primary" class="dialog-btn" [disabled]="!canRun" (click)="onRunClick()"><span class="text-bold">{{result ? runAgainButtonText : runButtonText}}</span></a>
  </div>
</mat-dialog-actions>
